import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '@/store/hooks'
import { setMenus, setPermissions } from '@/store/slices/userSlice'
import { mockLoginUser, mockMenuTree } from '@/mock'
import { isMenuTreeOutdated } from '@/utils/menu'
import { Spin } from 'antd'

interface AuthGuardProps {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const { token, menus } = useAppSelector((state) => state.user)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    // 检查认证状态
    if (!token) {
      // 如果没有token，跳转到登录页
      navigate('/login', { 
        replace: true,
        state: { from: location.pathname }
      })
      setIsChecking(false)
      return
    }

    // 菜单未加载或 Persist 中为旧版菜单时，从 mock 同步（含 Web3 等新增项）
    if (token && isMenuTreeOutdated(menus)) {
      dispatch(setMenus(mockMenuTree))
      dispatch(setPermissions(mockLoginUser.permissions || []))
    }

    setIsChecking(false)
  }, [token, navigate, location.pathname, dispatch, menus])

  // 如果正在检查或没有token，显示loading或不渲染
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    )
  }

  // 如果没有token，不渲染任何内容（应该已经跳转到登录页）
  if (!token) {
    return null
  }

  return <>{children}</>
}

export default AuthGuard
